import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../store';

/**
 * Navigation Component
 * Global navigation bar shown on all pages except public leaderboard
 */
export function Navigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  // Don't show nav on screencast leaderboard
  if (location.pathname.startsWith('/screencast/')) {
    return null;
  }

  // Don't show nav if not authenticated
  if (!isAuthenticated) {
    return null;
  }

  return (
    <nav className="bg-secondary-bg border-b border-border sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-2 sm:px-4 py-2 sm:py-3">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 hover:opacity-80 transition-opacity"
          >
            <img 
              src="/logo.png" 
              alt="Fight Night Bookie" 
              className="h-8 sm:h-10 w-auto"
            />
          </button>

          {/* Navigation Links - Compact for mobile */}
          <div className="flex items-center gap-1 sm:gap-2 md:gap-4">
            <button
              onClick={() => navigate('/games')}
              className={`px-2 sm:px-3 py-2 text-xs sm:text-sm font-medium transition-colors ${
                location.pathname === '/games' || location.pathname === '/create'
                  ? 'text-primary-blue border-b-2 border-primary-blue'
                  : 'text-secondary-text hover:text-primary-text'
              }`}
            >
              Events
            </button>
            <button
              onClick={() => navigate('/leaderboard')}
              className={`hidden md:block px-3 py-2 text-sm font-medium transition-colors ${
                location.pathname === '/leaderboard'
                  ? 'text-primary-blue border-b-2 border-primary-blue'
                  : 'text-secondary-text hover:text-primary-text'
              }`}
            >
              Leaderboard
            </button>
            <button
              onClick={() => navigate('/account')}
              className={`px-2 sm:px-3 py-2 text-xs sm:text-sm font-medium transition-colors ${
                location.pathname === '/account'
                  ? 'text-primary-blue border-b-2 border-primary-blue'
                  : 'text-secondary-text hover:text-primary-text'
              }`}
            >
              Account
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}

